import React, { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import infoIcon from "../../../assets/icons/info.svg";

const InlineTooltip = ({ content, imgClass }) => {
    const [showContent, setShowContent] = useState(false);
    const [coords, setCoords] = useState({ top: 0, left: 0 });
    const iconRef = useRef(null);
    const tooltipRef = useRef(null);

    // Create portal root if not present
    useEffect(() => {
        let el = document.getElementById("portal-root");
        if (!el) {
            el = document.createElement("div");
            el.id = "portal-root";
            document.body.appendChild(el);
        }
    }, []);

    // Position tooltip when opened
    useEffect(() => {
        if (showContent && iconRef.current) {
            const rect = iconRef.current.getBoundingClientRect();
            setCoords({
                top: rect.top + rect.height / 2,
                left: rect.right + 12
            });
        }
    }, [showContent]);

    // Close on outside click
    useEffect(() => {
        const handler = (e) => {
            if (
                tooltipRef.current &&
                !tooltipRef.current.contains(e.target) &&
                !iconRef.current.contains(e.target)
            ) {
                setShowContent(false);
            }
        };
        document.addEventListener("click", handler, true);
        return () => document.removeEventListener("click", handler, true);
    }, []);

    return (
        <>
            {/* Trigger Icon */}
            <div className="relative">
                <span
                    ref={iconRef}
                    className="inline-flex items-center justify-center w-4 h-4 cursor-pointer"
                    onClick={() => setShowContent(!showContent)}
                >
                    <img src={infoIcon} alt="" className={`w-full ${imgClass}`} />
                </span>

            </div>

            {/* Portal Tooltip */}
            {showContent &&
                ReactDOM.createPortal(
                    <div
                        ref={tooltipRef}
                        className="fixed z-[999999] px-3 py-2 text-sm text-white bg-gray-900 rounded-lg shadow w-max"
                        style={{
                            top: coords.top,
                            left: coords.left,
                            transform: "translateY(-50%)"
                        }}
                    >
                        {content}

                        {/* Arrow */}
                        <div
                            className="absolute w-0 h-0 border-y-8 border-y-transparent border-r-[8px] border-r-gray-900"
                            style={{
                                left: "-8px",
                                top: "50%",
                                transform: "translateY(-50%)"
                            }}
                        ></div>
                    </div>,
                    document.getElementById("portal-root")
                )}
        </>
    );
};

export default InlineTooltip;
